import React, { useEffect, useState, useCallback } from 'react';
import multiavatar from '@multiavatar/multiavatar';
import api from '../services/api';
import useAuth from './useAuth';
import Student from '../models/Student';

interface StudentAvatar {
  uri: string;
}

export const useAvatarUrl = () => {
  const { user } = useAuth();
  const [userAvatar, setUserAvatar] = useState<StudentAvatar>({
    uri: '',
  });

  const encodeAvatar = useCallback((avatarToken: string) => {
    const svgCode = multiavatar(avatarToken);
    return `data:image/svg+xml;utf8,${encodeURIComponent(svgCode)}`;
  }, []);

  const getRandomAvatar = useCallback((userToken: string) => {
    const svgCode = multiavatar(userToken);
    return `data:image/svg+xml;utf8,${encodeURIComponent(svgCode)}`;
  }, []);

  const getAvatarUrl = useCallback(
    (avatarToken: string) => {
      if (avatarToken.includes('http')) {
        return avatarToken;
      }
      return encodeAvatar(avatarToken);
    },
    [encodeAvatar],
  );

  const updateAvatar = useCallback(
    async (avatarToken: string) => {
      await api.put(`/students/update`, {
        id: user.id,
        avatarUri: avatarToken,
      });
      const student = localStorage.getItem('@itus:student-user');
      if (student) {
        const parsedStudent: Student = JSON.parse(student);
        parsedStudent.avatarUri = avatarToken;
        localStorage.setItem(
          '@itus:student-user',
          JSON.stringify(parsedStudent),
        );
      }

      setUserAvatar({ uri: getAvatarUrl(avatarToken) });
    },
    [user.id, getAvatarUrl],
  );

  const generateRandomAvatarToken = () => {
    let result = '';
    const characters =
      'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    for (let i = 0; i < 6; i += 1) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  };

  const resetAvatar = async () => {
    const avatarToken = generateRandomAvatarToken();
    await updateAvatar(avatarToken);
  };

  useEffect(() => {
    const getAvatar = () => {
      if (user.avatarUri) {
        setUserAvatar({ uri: getAvatarUrl(user.avatarUri) });
      } else {
        const avatarToken = user.profile.name ?? 'Usuário';
        updateAvatar(avatarToken);
      }
    };

    getAvatar();
  }, [user, getAvatarUrl, updateAvatar]);

  return { userAvatar, resetAvatar, getRandomAvatar };
};
